import { IUser } from '../interfaces/IUser'

export class User implements IUser {
    constructor(firstName?: string, lastName?: string, domainName?: string, isLoggedIn?: boolean) {
        this.firstName = (firstName === undefined ? '' : firstName);
        this.lastName = (lastName === undefined ? '' : lastName);
        this.domainName = (domainName === undefined ? '' : domainName);
        this.isLoggedIn = (isLoggedIn === undefined ? false : isLoggedIn);
    }

    firstName: string = "";
    lastName: string = "";
    domainName: string = "";
    isLoggedIn: boolean = false;

    pageTitle: string = "";
}